export class SimulatorBooking {
  type: string;
  meta: any;
  customer?: any;
  id?: number;
}
